/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { PagedAsyncIterableIterator } from "@azure/core-paging";
import {
  GlobalParameterResource,
  GlobalParametersListByFactoryOptionalParams,
  GlobalParametersGetOptionalParams,
  GlobalParametersGetResponse,
  GlobalParametersCreateOrUpdateOptionalParams,
  GlobalParametersCreateOrUpdateResponse,
  GlobalParametersDeleteOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a GlobalParameters. */
export interface GlobalParameters {
  /**
   * Lists Global parameters
   * @param resourceGroupName The resource group name.
   * @param factoryName The factory name.
   * @param options The options parameters.
   */
  listByFactory(
    resourceGroupName: string,
    factoryName: string,
    options?: GlobalParametersListByFactoryOptionalParams,
  ): PagedAsyncIterableIterator<GlobalParameterResource>;
  /**
   * Gets a Global parameter
   * @param resourceGroupName The resource group name.
   * @param factoryName The factory name.
   * @param globalParameterName The global parameter name.
   * @param options The options parameters.
   */
  get(
    resourceGroupName: string,
    factoryName: string,
    globalParameterName: string,
    options?: GlobalParametersGetOptionalParams,
  ): Promise<GlobalParametersGetResponse>;
  /**
   * Creates or updates a Global parameter
   * @param resourceGroupName The resource group name.
   * @param factoryName The factory name.
   * @param globalParameterName The global parameter name.
   * @param defaultParam Global parameter resource definition.
   * @param options The options parameters.
   */
  createOrUpdate(
    resourceGroupName: string,
    factoryName: string,
    globalParameterName: string,
    defaultParam: GlobalParameterResource,
    options?: GlobalParametersCreateOrUpdateOptionalParams,
  ): Promise<GlobalParametersCreateOrUpdateResponse>;
  /**
   * Deletes a Global parameter
   * @param resourceGroupName The resource group name.
   * @param factoryName The factory name.
   * @param globalParameterName The global parameter name.
   * @param options The options parameters.
   */
  delete(
    resourceGroupName: string,
    factoryName: string,
    globalParameterName: string,
    options?: GlobalParametersDeleteOptionalParams,
  ): Promise<void>;
}
